import WachatRoom from './wachat_room';
import WachatAddRoom from './wachat_add_room';
import WachatUserSettings from './wachat_user_settings';
import { get_rooms, mark_message_read } from './wachat_utils';

export default class WachatList {
  constructor(opts) {
    this.$wrapper = opts.$wrapper;
    this.user = opts.user;
    this.user_email = opts.user_email;
    this.is_admin = opts.is_admin;
    this.setup();
  }

  setup() {
    this.$wachat_list = $(document.createElement('div'));
    this.$wachat_list.addClass('wachat-list');
    this.setup_header();
    this.setup_search();
    this.fetch_and_setup_rooms();
    this.setup_socketio();
  }

  setup_header() {
    const wachat_list_header_html = `
			<div class='wachat-list-header'>
				<h3>${__('Wachats')}</h3>
        <div class='wachat-list-icons'>
          <div class='wa-user-settings' 
          title='Settings'>
          ${frappe.utils.icon('setting-gear', 'md')}
          </div>
        </div>
			</div>
		`;
    this.$wachat_list.append(wachat_list_header_html);
  }

  setup_search() {
    const wachat_list_search_html = `
		<div class='wachat-search'>
			<div class='input-group'>
				<input class='form-control wachat-search-box'
				type='search' 
				placeholder='${__('Search conversation')}'
				>	
				<span class='search-icon'>
					${frappe.utils.icon('search', 'sm')}
				</span>
			</div>
		</div>
		`;
    this.$wachat_list.append(wachat_list_search_html);
  }

  async fetch_and_setup_rooms() {
    try {
      const res = await get_rooms(this.user_email);
      this.rooms = res;
      this.setup_rooms();
      this.render_messages();
    } catch (error) {
      frappe.msgprint({
        title: __('Error'),
        message: __('Something went wrong. Please refresh and try again.'),
      });
    }
  }

  setup_rooms() {
    this.$wachat_rooms_container = $(document.createElement('div'));
    this.$wachat_rooms_container.addClass('wachat-rooms-container');
    this.wachat_rooms = [];

    this.rooms.forEach((element) => {
      let profile = {
        user: this.user,
        user_email: this.user_email,
        last_message: element.last_message,
        last_date: element.modified,
        is_admin: this.is_admin,
        room: element.name,
        is_read: element.is_read,
        room_name: element.room_name,
        room_type: element.type,
        opposite_person_email: element.opposite_person_email,
      };
      this.wachat_rooms.push([
        profile.room,
        new WachatRoom({
          $wrapper: this.$wrapper,
          $wachat_rooms_container: this.$wachat_rooms_container,
          wachat_list: this,
          element: profile,
        }),
      ]);
    });
    this.$wachat_list.append(this.$wachat_rooms_container);
  }

  fitler_rooms(query) {
    for (const room of this.wachat_rooms) {
      const txt = room[1].profile.room_name.toLowerCase();
      if (txt.includes(query)) {
        room[1].$wachat_room.show();
      } else {
        room[1].$wachat_room.hide();
      }
    }
  }

  create_new_room(profile) {
    this.wachat_rooms.unshift([
      profile.room,
      new WachatRoom({
        $wrapper: this.$wrapper,
        $wachat_rooms_container: this.$wachat_rooms_container,
        wachat_list: this,
        element: profile,
      }),
    ]);
    this.wachat_rooms[0][1].render('prepend');
  }

  setup_events() {
    const me = this;
    $('.wachat-search-box').on('input', function (e) {
      me.fitler_rooms($(this).val().toLowerCase());
    });


    $('.wa-user-settings').on('click', function (e) {
      if (typeof me.wachat_user_settings === 'undefined') {
        me.wachat_user_settings = new WachatUserSettings();
      }
      me.wachat_user_settings.show();
    });
  }

  render_messages() {
    this.$wachat_rooms_container.empty();
    for (const element of this.wachat_rooms) {
      element[1].render('append');
    }
  }

  render() {
    this.$wrapper.html(this.$wachat_list);
    this.setup_events();
  }

  move_room_to_top(wachat_room_item) {
    this.wachat_rooms = [
      wachat_room_item,
      ...this.wachat_rooms.filter((item) => item !== wachat_room_item),
    ];
  }

  setup_socketio() {
    const me = this;
    frappe.realtime.on('latest_wachat_updates', function (res) {
      //Find the room with the specified room id
      const wachat_room_item = me.wachat_rooms.find(
        (element) => element[0] === res.room
      );

      if (typeof wachat_room_item === 'undefined') {
        return;
      }

      if (
        !$('.wachat-element').is(':visible') &&
        frappe.Wachat.settings.user.enable_notifications === 1
      ) {
        frappe.utils.play_sound('wachat-notification');
      }

      const message =
        res.content.length > 24
          ? res.content.substring(0, 24) + '...'
          : res.content;

      wachat_room_item[1].set_last_message(message, res.creation);

      if ($('.wachat-list').length) {
        wachat_room_item[1].set_as_unread();
        wachat_room_item[1].move_to_top();
        me.move_room_to_top(wachat_room_item);
      } else if ($('.wachat-space').length) {
        mark_message_read(res.room);
      }
    });

    frappe.realtime.on('new_room_creation', function (res) {
      if (
        !$('.wachat-element').is(':visible') &&
        frappe.Wachat.settings.user.enable_notifications === 1
      ) {
        frappe.utils.play_sound('wachat-notification');
      }

      res.user = me.user;
      res.is_admin = me.is_admin;
      res.user_email = me.user_email;
      me.create_new_room(res);
    });

    frappe.realtime.on('wachat_private_room_creation', function (res) {
      if (
        !$('.wachat-element').is(':visible') &&
        frappe.Wachat.settings.user.enable_notifications === 1
      ) {
        frappe.utils.play_sound('wachat-notification');
      }

      if (res.members.includes(me.user_email)) {
        if (res.room_type === 'Direct') {
          res.room_name =
            res.member_names[0]['email'] == me.user_email
              ? res.member_names[1]['name']
              : res.member_names[0]['name'];

          res.opposite_person_email =
            res.member_names[0]['email'] == me.user_email
              ? res.member_names[1]['email']
              : res.member_names[0]['email'];
        }

        res.user = me.user;
        res.is_admin = me.is_admin;
        res.user_email = me.user_email;
        me.create_new_room(res);
      }
    });
  }
}
